// メニュー定義 (Firestore HozenallCloud_Roles_Permissions) の path が外部 URL かを判定する
// 外部 URL は画面内遷移 (react-router) ではなく新しいタブで開く
export const isExternalMenuPath = (path?: string | null): path is string =>
  !!path && /^https?:\/\//i.test(path);

// 外部 URL を新しいタブで開く (遷移元ウィンドウへの参照を渡さない)
export const openExternalMenuPath = (path: string): void => {
  window.open(path, '_blank', 'noopener,noreferrer');
};
